import { useAuth } from "@/context/AuthContext";
import { useMemberSellerWallet } from "@/hooks/useMemberSellerWallet";
import { cn } from "@/lib/utils";
import { Loader2, Wallet } from "lucide-react";

/** Solde / KYC vendeur dans la barre du haut (clic = valider identité ou configurer versements). */
export default function MemberHeaderWallet() {
  const { user } = useAuth();
  const { phase, label, hint, loading, handleClick } = useMemberSellerWallet();

  if (!user || user.role === "admin") return null;

  const actionable = phase !== "loading";
  const needsAction = phase === "kyc_required" || phase === "kyc_pending" || phase === "connect_required";

  return (
    <button
      type="button"
      onClick={actionable ? () => void handleClick() : undefined}
      disabled={!actionable}
      className={cn(
        "flex max-w-[min(100%,11rem)] min-w-0 items-center gap-2 rounded-lg border px-2.5 py-1.5 text-left transition-colors sm:max-w-[14rem] sm:px-3 sm:py-2",
        needsAction
          ? "border-amber-200/90 bg-amber-50/90 hover:bg-amber-100/90"
          : "border-emerald-200/80 bg-emerald-50/80 hover:bg-emerald-100/80",
        !actionable && "opacity-80",
      )}
      data-testid="member-header-wallet"
      aria-label={
        needsAction
          ? label
          : `Solde vendeur disponible : ${label}${hint ? `, ${hint}` : ""}`
      }
    >
      <span
        className={cn(
          "flex h-8 w-8 shrink-0 items-center justify-center rounded-lg",
          needsAction ? "bg-amber-500/15 text-amber-800" : "bg-[#2D7FF9]/12 text-[#2D7FF9]",
        )}
        aria-hidden
      >
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Wallet className="h-4 w-4" strokeWidth={2} />}
      </span>
      <span className="min-w-0 flex-1">
        <span
          className={cn(
            "block truncate text-xs font-semibold tabular-nums",
            phase === "ready" ? "font-display text-sm font-black text-[#0B0D12]" : "text-amber-950",
          )}
        >
          {label}
        </span>
        {hint ? (
          <span className="mt-0.5 block truncate text-[10px] leading-tight text-slate-500">{hint}</span>
        ) : null}
      </span>
    </button>
  );
}
